module.exports = "/_next/static/images/2a290bc68c24220a5d1756429b95fd3a-hero-lg.png.webp";